export function Spinner({ size = 16 }: { size?: number }) {
  return (
    <svg
      className="animate-spin text-slate-400"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      aria-label="Töltés"
    >
      <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" />
      <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 0 1 8-8v4a4 4 0 0 0-4 4H4z" />
    </svg>
  )
}

export function CenterSpinner({ label = 'Töltés…' }: { label?: string }) {
  return (
    <div className="flex flex-col items-center justify-center gap-2 py-12 text-sm text-slate-500">
      <Spinner size={24} />
      <span>{label}</span>
    </div>
  )
}
